import { firestore } from "@/firebase";
//import firebase from "firebase/app";
//import "firebase/auth";

const state = {
  clients: []
};

const getters = {
  clients: state => state.clients
};

const mutations = {
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  }
};

let clientsSubscription;

const actions = {
  subscribe({ commit, rootState }) {
    clientsSubscription = firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .orderBy("name", "asc")
      .onSnapshot(querySnapshot => {
        const all = querySnapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
        commit("SET_CLIENTS", all);
      });
  },
  unsubscribe() {
    clientsSubscription();
    // commit("SET_CLIENTS", []);
  },
  async add({ rootState, dispatch }, payload) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .add({ ...payload, created: Date.now(), updated: Date.now() });
    dispatch(
      "addToast",
      {
        message: "Added client!",
        type: "good"
      },
      { root: true }
    );
  },
  async delete({ rootState, dispatch }, clientId) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(clientId)
      .delete();
    // DELETE TESTS
    dispatch(
      "addToast",
      {
        message: "Deleted client!",
        type: "pending"
      },
      { root: true }
    );
  },
  async get({ rootState }, clientId) {
    return await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(clientId)
      .get()
      .then(doc => {
        return { id: clientId, ...doc.data() };
      });
  },
  async save({ rootState }, payload) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(payload.id)
      .update({ ...payload, updated: Date.now() });
  },
  async updated({ rootState }, payload) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(payload.id)
      .update({ updated: Date.now() });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
